import css from "@styled-system/css";
import styled from "styled-components";

export const Lead = styled("h2")(
  css({
    fontSize: [3, 5],
    fontWeight: 300,
    my: 75,
  })
);

export const Description = styled("div")(
  css({
    "> :first-child": {
      marginTop: 0,
    },
    "> :last-child": {
      marginBottom: 0,
    },

    h3: {
      fontSize: [3, 4],
      my: "1em",
    },

    h4: {
      fontSize: [2, 3],
      my: "1em",
    },

    p: {
      fontSize: [1, 3],
      my: "1em",
    },
    ul: {
      fontSize: [1, 3],
      mx: 0,
      my: "1em",
      li: {
        my: "0.5em",
      },
    },
  })
);
